import { Controller } from "@hotwired/stimulus"

// 산업분류 Cascading Select 컨트롤러
// 대분류 선택 시 해당하는 중분류 옵션을 동적으로 업데이트
// Fomantic UI Dropdown과 호환
export default class extends Controller {
  static targets = ["majorInput", "minorWrapper", "minorInput", "minorMenu", "minorText", "minorTextInput"]
  static values = {
    classification: { type: Object, default: {} }
  }

  connect() {
    // 초기 로드 시 대분류가 이미 선택되어 있으면 중분류 옵션 업데이트
    if (this.hasMajorInputTarget && this.majorInputTarget.value) {
      this.waitForJQuery().then(() => {
        setTimeout(() => this.updateMinorOptions(false), 100)
      })
    }
  }

  waitForJQuery() {
    return new Promise((resolve) => {
      if (typeof $ !== 'undefined' && $.fn && $.fn.dropdown) {
        resolve()
        return
      }
      const checkInterval = setInterval(() => {
        if (typeof $ !== 'undefined' && $.fn && $.fn.dropdown) {
          clearInterval(checkInterval)
          resolve()
        }
      }, 50)
      setTimeout(() => {
        clearInterval(checkInterval)
        resolve()
      }, 3000)
    })
  }

  // 대분류 변경 시 호출 (hidden input의 change 이벤트)
  majorChanged(event) {
    this.updateMinorOptions(true)
  }

  updateMinorOptions(clearValue = true) {
    const majorValue = this.hasMajorInputTarget ? this.majorInputTarget.value : ""

    if (!this.hasMinorWrapperTarget) {
      return
    }

    const $minorDropdown = $(this.minorWrapperTarget).find('.ui.dropdown')
    const isOther = majorValue === '기타'

    // '기타' 선택 시 text input 표시, 아니면 dropdown 표시
    if (this.hasMinorTextInputTarget) {
      if (isOther) {
        // dropdown 숨기고 text input 표시
        this.minorWrapperTarget.classList.add('hidden')
        this.minorTextInputTarget.classList.remove('hidden')
        // dropdown의 hidden input을 disabled 처리 (폼 제출 시 제외)
        if (this.hasMinorInputTarget) {
          this.minorInputTarget.disabled = true
        }
        // text input 활성화
        this.minorTextInputTarget.disabled = false
        if (clearValue) {
          this.minorTextInputTarget.value = ""
        }
        return
      } else {
        // text input 숨기고 dropdown 표시
        this.minorTextInputTarget.classList.add('hidden')
        this.minorWrapperTarget.classList.remove('hidden')
        // text input을 disabled 처리 (폼 제출 시 제외)
        this.minorTextInputTarget.disabled = true
        // dropdown의 hidden input 활성화
        if (this.hasMinorInputTarget) {
          this.minorInputTarget.disabled = false
        }
      }
    }

    if (!this.hasMinorMenuTarget) {
      return
    }

    if (!majorValue || !this.classificationValue[majorValue]) {
      // 대분류가 선택되지 않으면 중분류 비활성화
      $minorDropdown.addClass("disabled")
      if (clearValue) {
        try {
          $minorDropdown.dropdown('clear')
        } catch (e) {}
      }
      // 메뉴 비우기
      this.minorMenuTarget.innerHTML = ""
      return
    }

    // 해당 대분류의 중분류 옵션으로 메뉴 업데이트
    const minorOptions = this.classificationValue[majorValue]

    // 기존 dropdown destroy
    try {
      $minorDropdown.dropdown('destroy')
    } catch (e) {
      // ignore
    }

    // 메뉴 아이템 생성
    this.minorMenuTarget.innerHTML = ""
    minorOptions.forEach(option => {
      const itemDiv = document.createElement("div")
      itemDiv.className = "item"
      itemDiv.setAttribute("data-value", option)
      itemDiv.textContent = option
      this.minorMenuTarget.appendChild(itemDiv)
    })

    // 중분류 활성화
    $minorDropdown.removeClass("disabled")

    // 값 초기화 (대분류 변경 시)
    if (clearValue && this.hasMinorInputTarget) {
      this.minorInputTarget.value = ""
      // 텍스트 초기화
      if (this.hasMinorTextTarget) {
        this.minorTextTarget.textContent = "선택하세요"
        this.minorTextTarget.className = "default text"
      }
    }

    // Fomantic UI dropdown 재초기화
    $minorDropdown.dropdown({
      placeholder: '선택하세요',
      clearable: true,
      duration: 0,
      transition: 'none',
      onChange: (value, text, $selectedItem) => {
        // hidden input에 change 이벤트 dispatch
        if (this.hasMinorInputTarget) {
          this.minorInputTarget.dispatchEvent(new Event('change', { bubbles: true }))
        }
      }
    })
  }
}
